import { render, staticRenderFns } from "./Household.vue?vue&type=template&id=5ffb471b&scoped=true&"
import script from "./Household.vue?vue&type=script&lang=js&"
export * from "./Household.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffb471b",
  null
  
)

export default component.exports